<template>
  <div>
    <table class="table table-bordered tableinfo">
      <tr>
        <td>
          <b>Nome do Programa de Afiliados:</b>
          {{dados.nome}}
        </td>
      </tr>
    </table>
  </div>
</template>

<script>
export default {
  props: ["dados"],

  components: {},
  
  data() {
    return {};
  }
};
</script>
<style lang="scss" scoped>
.tableinfo td {
  width: 1%;
}
</style>
